import { useRef } from 'react'

export default function useScrollToTop() {
  return useRef(null)
}
